import type { ProfileIconId, SessionUser } from '@trove/contracts';
import { profileIconEmoji } from '../profileIcons';
import styles from './ProfileAvatar.module.css';

type ProfileAvatarProps = {
  user: Pick<SessionUser, 'displayName' | 'icon' | 'iconBackground'>;
  size?: 'sm' | 'md';
  className?: string;
};

export function ProfileAvatar({ user, size = 'sm', className }: ProfileAvatarProps) {
  const emoji = profileIconEmoji(user.icon as ProfileIconId);

  return (
    <span
      className={`${styles.avatar} ${size === 'md' ? styles.md : styles.sm}${className ? ` ${className}` : ''}`}
      data-background={user.iconBackground}
    >
      <span className={styles.emoji} aria-hidden="true">
        {emoji}
      </span>
    </span>
  );
}
